import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { successToast } from 'helpers';
import { RequestParams, ShopSettingTypes } from 'models';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  fetchLogSettingAPI,
  fetchShopSettingAPI,
  getPermissionByUserAPI,
  updatePermissionStaffAPI,
  updateShopSettingsAPI,
} from 'redux/api/shopSettingApi';
import { shopSettingActions } from 'slices/shopSettingSlice';
import { shopListAction } from 'slices/shopSlice';

function* fetchShopSettingSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse<ShopSettingTypes> = yield call(fetchShopSettingAPI, token, params);
    if (res?.data) {
      yield put(
        shopSettingActions.getShopSettingSuccess({
          data: res.data,
          shopId: action.payload.params.shop_id,
        })
      );
    }
  } catch (error) {
    console.log('error', error);
  }
}
function* updateShopSettingsSaga(action: any) {
  const { token, data } = action.payload;

  try {
    const res: AxiosResponse = yield call(updateShopSettingsAPI, token, data);
    res.data.tax_type = JSON.parse(res.data.tax_type);
    res.data.tax = res.data.percent;
    yield put(
      shopSettingActions.updateShopSettingsSuccess({
        data: res.data,
        shopId: res.data.shop_id,
      })
    );
    successToast('ショップ設定の更新に成功しました');
  } catch (error) {
    console.log(error);
  }
}
function* fetchShopLogSettingSaga(
  action: PayloadAction<{
    token: string;
    params: {
      shop_ids: Array<number>;
      shop_id?: number;
      type_get: string;
      type: Array<string | number>;
      date: string;
    };
  }>
) {
  const { token, params } = action.payload;

  try {
    const res: AxiosResponse = yield call(fetchLogSettingAPI, token, params);
    const { status, data } = res;
    if (status == 200) {
      yield put(shopSettingActions.getShopLogSettingSuccess(data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* fetchPermissionByUserSaga(
  action: PayloadAction<{
    token: string;
  }>
) {
  const { token } = action.payload;

  try {
    const res: AxiosResponse = yield call(getPermissionByUserAPI, token);
    const { status, data } = res;
    if (status == 200) {
      yield put(shopSettingActions.getPermissionByUserSuccess(data));
    }
  } catch (error) {
    console.log(error);
    yield put(shopSettingActions.getPermissionByUserFailed());
  }
}
function* updatePermissionStaffSaga(
  action: PayloadAction<{
    token: string;
    dataBody: {
      permission: Array<{
        name: string;
        active: number;
        app_name: Array<number>;
        shop_id: number;
        id?: number;
      }>;
    };
  }>
) {
  const { token, dataBody } = action.payload;

  try {
    const res: AxiosResponse = yield call(updatePermissionStaffAPI, token, dataBody);
    const { status, data } = res;
    if (status == 200) {
      yield put(shopSettingActions.updatePermissionStaffSuccess(data));
      const isMasterUpdateShopPerMissionStaff = dataBody.permission.find(
        (item) => item.name === 'enable_ranking_program_master'
      );
      if (isMasterUpdateShopPerMissionStaff) {
        yield put(shopListAction.masterEnableShopPermissionStaffSuccess(dataBody.permission));
      }
    }
  } catch (error) {
    console.log(error);
    yield put(shopSettingActions.updatePermissionStaffFailed());
  }
}
export default function* shopSettingSaga() {
  yield takeEvery(shopSettingActions.getShopSetting.type, fetchShopSettingSaga);
  yield takeLatest(shopSettingActions.updateShopSettings.type, updateShopSettingsSaga);
  yield takeLatest(shopSettingActions.getShopLogSetting.type, fetchShopLogSettingSaga);
  yield takeLatest(shopSettingActions.updatePermissionStaff.type, updatePermissionStaffSaga);
  yield takeLatest(shopSettingActions.getPermissionByUser.type, fetchPermissionByUserSaga);
}
